export default __webpack_public_path__ + "static/media/OralHistory2.963325be.png";